import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import FormInput from '../../../components/FormHelpers/formField';
import BaseButton from '../../../components/button/BaseButton';
import {getUser, isSchoolUser} from '../../../utils/userUtility';
import './styles.scss';
import SelectInstrument from '../../../components/selectInstrument/SelectInstrument';
import {customEvent} from "../../../utils/analyticsUtil";
import {category, DialogTypes, events} from "../../../constants/enums";
import emailIcon from '../../../assets/images/student-form-mail-icon.svg'

const DEFAULT_NAME = {given: "Ziggy", family: "Stardust"};

@injectIntl
@inject('manageStore', 'inviteMemberStore', 'dialogStore', 'onBoardingStore')
@observer
class InviteStudentForm extends Component {

    componentDidMount() {
        if (this.props.instrument) {
            this.handleInstrumentChange(this.props.instrument);
        }

        let {inviteMemberStore, withDefaultName} = this.props;
        let {onChange, form} = inviteMemberStore;
        if (withDefaultName && !form.fields.name.value) {
            onChange('name', DEFAULT_NAME.given);
        }
        if (withDefaultName && !form.fields.familyName.value) {
            onChange('familyName', DEFAULT_NAME.family);
        }

        if (!inviteMemberStore.isConnectMode) {
            inviteMemberStore.setAvatar();
        }
    }

    onSelectInstrument = (e) => {
        this.handleInstrumentChange(e.value);
    };

    handleInstrumentChange = (value) => {
        this.props.inviteMemberStore.setChip(value, 'instrument');
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const {onSubmit, inviteMemberStore, manageStore, intl: {formatMessage: translate}, disableNotification, dialogStore} = this.props;
        const {validateForm, inviteStudent, connectStudent, form, avatar, isConnectMode, setError} = inviteMemberStore;
        if (validateForm()) {
            const email = form.fields.email.value.toLowerCase();
            const name = form.fields.name.value.trim();
            const familyName = form.fields.familyName.value.trim();
            const instrument = form.fields.instrument.value;
            if (email && manageStore.isExistStudent(email)) {
                setError(translate({id: 'addStudent.isAlreadyStudent'}));
                return;
            }
            if (getUser().email === email) {
                setError(translate({id: 'addStudent.isThisUsersEmail'}, {name}));
                return;
            }
            if (isConnectMode) {
                connectStudent(email, name, familyName, avatar);
            } else {
                if (onSubmit) {
                    onSubmit();
                }
                const student = await inviteStudent(email, name, familyName, avatar, instrument, disableNotification, false);
                customEvent(events.CustomEvent, {category: category.AddStudent});
                if (student) {
                    dialogStore.openDialog(DialogTypes.StudentAddConfirmDialog)
                }
            }
        }
    };

    render() {
        const {className, submitLabel, inviteMemberStore, showEmail, intl: {formatMessage: translate}} = this.props;
        const {form, isConnectMode, onChange, onBlur, isProcessing} = inviteMemberStore;
        const isDisabledSubmit = isConnectMode || isSchoolUser() ? !form.meta.isValid || !form.fields.email.value || isProcessing : !form.meta.isValid || isProcessing;

        return (
            <form className={`invite-form ${className || ''}`} onSubmit={this.handleSubmit}>
                <div className="form-cols">
                    <div className="fieldset">
                        <div className="input-student-name-group">
                            <FormInput
                                className="input-student-name marked"
                                name="name"
                                type="text"
                                placeholder={translate({id: 'addStudent.placeholder.name'})}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={form.fields.name.value}
                                error={form.fields.name.error}
                            />
                            <FormInput
                                className="input-student-name"
                                name="familyName"
                                type="text"
                                placeholder={translate({id: 'addStudent.placeholder.familyName'})}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={form.fields.familyName.value}
                                error={form.fields.familyName.error}
                            />
                        </div>
                        {!isSchoolUser() && <SelectInstrument onChange={this.onSelectInstrument} instrument={form.fields.instrument}/>}
                        {showEmail &&
                        <div>
                            <div>
                                <div className='email-input-wrapper'>
                                    <img src={emailIcon}/>
                                    <h4><FormattedMessage id="manage.invite.student.byEmail"/></h4>
                                </div>
                                <p><FormattedMessage id="addStudent.form.email.description"/></p>
                            </div>
                            <FormInput
                                className={`input-student-name ${(isConnectMode || isSchoolUser()) ? 'marked' : ''}`}
                                name="email"
                                type="email"
                                placeholder={translate({id: 'addStudent.placeholder.email'})}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={form.fields.email.value}
                                error={form.fields.email.error}
                            />
                        </div>}


                    </div>
                    {form.meta.error && <div className="a-form-error meta">{form.meta.error}</div>}
                </div>
                <BaseButton
                    disabled={isDisabledSubmit}
                    className="invite-modal-btn"
                    type="submit"
                    onClick={this.handleSubmit}
                    label={translate({id: submitLabel || `addStudent.button.${isConnectMode ? 'connect' : 'done'}`})}
                />
            </form>
        );
    }
}

export default InviteStudentForm;
